export const settingsContext = {
  deliveryPeriods: '/order-service/rest/api/external/deliveryPeriods',
  deliveryPeriodsTree: '/order-service/rest/api/external/deliveryPeriods/tree',
  deliveryPeriod: '/order-service/rest/api/external/deliveryPeriods/{id}',
  deliveryPeriodMerchant: '/order-service/rest/api/external/deliveryPeriods/merchant',
  recovery: {
    deleteUnusedDeployments: '/order-service/rest/api/external/camunda/deleteUnusedDeployments',
    migrateDefinition: '/order-service/rest/api/external/camunda/migrateDefinition',
    recoverFailedJobs: '/order-service/rest/api/external/camunda/recoverFailedJobs',
  },
  currencyRates: {
    currencies: '/user-service/api/external/supportedCurrencies',
    currencyById: '/user-service/api/external/supportedCurrencies/{id}',
    currencyRates: '/user-service/api/external/currencyRates',
    forceCurrencyRatesImport: '/user-service/api/external/currencyRates/forceImportFromProvider',
  },
  relatedItems: {
    upload: `/item-service/api/external/items/related/upload`,
    delete: `/item-service/api/external/items/related/clear`,
    export: `/item-service/api/external/items/related/download`,
    byId: `/item-service/api/external/items/related/{id}`,
  },
  rules: {
    all: `/item-service/api/external/itemRules`,
    byId: `/item-service/api/external/itemRules/{id}`,
  },
  defaultSettings: {
    all: `/item-service/api/external/defaultSettings`,
  },
  metaship: {
    sellerInfo: '/logistics-service/api/external/metaship-v2/sellerInfo',
    warehouses: '/logistics-service/api/external/metaship-v2/warehouses',
    shops: '/logistics-service/api/external/metaship-v2/shops',
  },
  selfPickupProvider: '/logistics-service/api/external/self-pickup/sellerInfo',
  supportedProviders: '/logistics-service/api/external/supportedProviders',
  score: '/item-service/api/external/itemSortRatingCoefficients',
  search: {
    synonym: '/search-service/api/external/synonym',
  },
  catalogSettings: '/item-service/api/external/catalogSettings',
  buyerPriceTypes: {
    all: `/user-service/api/external/buyerPriceTypes`,
    byId: `/user-service/api/external/buyerPriceTypes/{id}`,
  },
  seoFiles: {
    all: '/media-service/api/external/seofiles',
    single: '/media-service/api/external/seofiles/name',
  },
};
